var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.50012H3C2.725 9.50012 2.48958 9.40221 2.29375 9.20637C2.09792 9.01054 2 8.77512 2 8.50012V1.50012C2 1.22512 2.09792 0.989705 2.29375 0.793872C2.48958 0.598039 2.725 0.500122 3 0.500122H6.5L9.5 3.50012V8.50012C9.5 8.77512 9.40208 9.01054 9.20625 9.20637C9.01042 9.40221 8.775 9.50012 8.5 9.50012ZM6 4.00012V1.50012H3V8.50012H8.5V4.00012H6ZM1 11.5001C0.725 11.5001 0.489583 11.4022 0.29375 11.2064C0.0979167 11.0105 0 10.7751 0 10.5001V3.50012H1V10.5001H6.5V11.5001H1Z",
    fill: "#002060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.fd0cf81c0c75dab5b92a5de2d33d4a48.svg";
export { ForwardRef as ReactComponent };